import { FeatureFlag } from '@sonar-software/sonar-core';
import { PeriscopeBodyComponent } from '@periscopes/types';
import React from 'react';

import { COPY_SPECIFIC, PERISCOPE_TAB_TYPES } from '@sonar-software/sonar-ts-constants';
import {
	EntityAutomationTab,
	EntityBulkTagTab,
	EntityDetailsTab,
	EntityFieldsTab,
	EntityLimitsTab,
	EntityRelatedObjectsTab,
	EntityReportsTab
} from '.';
import { PeriscopeMenuTabs, PeriscopeTabArea } from '@periscopes/general';
import { SfEntityAutomationType, SonarObjectChildTypeId, SonarObjectType } from '@sonar-software/sonar-ts-types';

export const EntityScope: PeriscopeBodyComponent = ({ data, index }) => {
	const { sonarObjectId, relatedCounts = {} } = data;

	return (
		<PeriscopeMenuTabs defaultKey={ PERISCOPE_TAB_TYPES.FIELDS }>
			<PeriscopeTabArea
				featureFlag={ FeatureFlag.DataDictionary }
				forceRender
				key={ PERISCOPE_TAB_TYPES.DETAILS }
				tab={ PERISCOPE_TAB_TYPES.DETAILS }>
				<EntityDetailsTab sonarObjectId={ sonarObjectId } />
			</PeriscopeTabArea>
			<PeriscopeTabArea
				count={ relatedCounts[ SonarObjectType.SalesforceField ] ?? 0 }
				key={ PERISCOPE_TAB_TYPES.FIELDS }
				requiresCount
				tab={ PERISCOPE_TAB_TYPES.FIELDS }>
				<EntityFieldsTab
					index={ index }
					sonarObjectId={ sonarObjectId } />
			</PeriscopeTabArea>
			<PeriscopeTabArea
				group={ PERISCOPE_TAB_TYPES.PROCESS_AUTOMATION }
				key={ COPY_SPECIFIC.ALL }
				submenu={ PERISCOPE_TAB_TYPES.REFERENCES }
				tab={ COPY_SPECIFIC.ALL }>
				<EntityAutomationTab
					childType={ SonarObjectChildTypeId.SalesforceAllProcessAutomations }
					index={ index }
					sonarObjectId={ sonarObjectId }
					type={ SfEntityAutomationType.AllProcessAutomations } />
			</PeriscopeTabArea>
			<PeriscopeTabArea
				count={ relatedCounts[ SonarObjectType.SalesforceValidationRule ] ?? 0 }
				group={ PERISCOPE_TAB_TYPES.PROCESS_AUTOMATION }
				key={ PERISCOPE_TAB_TYPES.VALIDATION_RULES }
				requiresCount
				submenu={ PERISCOPE_TAB_TYPES.REFERENCES }
				tab={ PERISCOPE_TAB_TYPES.VALIDATION_RULES }>
				<EntityAutomationTab
					childType={ SonarObjectChildTypeId.SalesforceValidationRule }
					index={ index }
					sonarObjectId={ sonarObjectId }
					type={ SfEntityAutomationType.ValidationRules } />
			</PeriscopeTabArea>
			<PeriscopeTabArea
				count={ relatedCounts[ SonarObjectType.SalesforceWorkflowRule ] ?? 0 }
				group={ PERISCOPE_TAB_TYPES.PROCESS_AUTOMATION }
				key={ PERISCOPE_TAB_TYPES.WORKFLOW_RULES }
				requiresCount
				submenu={ PERISCOPE_TAB_TYPES.REFERENCES }
				tab={ PERISCOPE_TAB_TYPES.WORKFLOW_RULES }>
				<EntityAutomationTab
					childType={ SonarObjectChildTypeId.SalesforceWorkflowRule }
					index={ index }
					sonarObjectId={ sonarObjectId }
					type={ SfEntityAutomationType.Workflows } />
			</PeriscopeTabArea>
			<PeriscopeTabArea
				count={ relatedCounts[ SonarObjectType.SalesforceFieldUpdate ] ?? 0 }
				group={ PERISCOPE_TAB_TYPES.PROCESS_AUTOMATION }
				key={ PERISCOPE_TAB_TYPES.FIELD_UPDATES }
				requiresCount
				submenu={ PERISCOPE_TAB_TYPES.REFERENCES }
				tab={ PERISCOPE_TAB_TYPES.FIELD_UPDATES }>
				<EntityAutomationTab
					childType={ SonarObjectChildTypeId.SalesforceFieldUpdate }
					index={ index }
					sonarObjectId={ sonarObjectId }
					type={ SfEntityAutomationType.FieldUpdates } />
			</PeriscopeTabArea>
			<PeriscopeTabArea
				count={ relatedCounts[ SonarObjectType.SalesforceEmailTemplate ] ?? 0 }
				group={ PERISCOPE_TAB_TYPES.PROCESS_AUTOMATION }
				key={ PERISCOPE_TAB_TYPES.EMAIL_TEMPLATES }
				requiresCount
				submenu={ PERISCOPE_TAB_TYPES.REFERENCES }
				tab={ PERISCOPE_TAB_TYPES.EMAIL_TEMPLATES }>
				<EntityAutomationTab
					childType={ SonarObjectChildTypeId.SalesforceEmailTemplate }
					index={ index }
					sonarObjectId={ sonarObjectId }
					type={ SfEntityAutomationType.EmailTemplate } />
			</PeriscopeTabArea>
			<PeriscopeTabArea
				count={ relatedCounts[ SonarObjectType.SalesforceFlow ] ?? 0 }
				group={ PERISCOPE_TAB_TYPES.PROCESS_AUTOMATION }
				key={ PERISCOPE_TAB_TYPES.FLOWS }
				requiresCount
				submenu={ PERISCOPE_TAB_TYPES.REFERENCES }
				tab={ PERISCOPE_TAB_TYPES.FLOWS }>
				<EntityAutomationTab
					childType={ SonarObjectChildTypeId.SalesforceFlow }
					index={ index }
					sonarObjectId={ sonarObjectId }
					type={ SfEntityAutomationType.Flows } />
			</PeriscopeTabArea>
			<PeriscopeTabArea
				count={ relatedCounts[ SonarObjectType.SalesforceProcessBuilder ] ?? 0 }
				group={ PERISCOPE_TAB_TYPES.PROCESS_AUTOMATION }
				key={ PERISCOPE_TAB_TYPES.PROCESS_BUILDERS }
				requiresCount
				submenu={ PERISCOPE_TAB_TYPES.REFERENCES }
				tab={ PERISCOPE_TAB_TYPES.PROCESS_BUILDERS }>
				<EntityAutomationTab
					childType={ SonarObjectChildTypeId.SalesforceProcessBuilder }
					index={ index }
					sonarObjectId={ sonarObjectId }
					type={ SfEntityAutomationType.ProcessBuilders } />
			</PeriscopeTabArea>
			<PeriscopeTabArea
				count={ relatedCounts[ SonarObjectType.SalesforceApexClass ] ?? 0 }
				group={ PERISCOPE_TAB_TYPES.PROCESS_AUTOMATION }
				key={ PERISCOPE_TAB_TYPES.APEX_CLASSES }
				requiresCount
				submenu={ PERISCOPE_TAB_TYPES.REFERENCES }
				tab={ PERISCOPE_TAB_TYPES.APEX_CLASSES }>
				<EntityAutomationTab
					childType={ SonarObjectChildTypeId.SalesforceApexClass }
					index={ index }
					sonarObjectId={ sonarObjectId }
					type={ SfEntityAutomationType.ApexClasses } />
			</PeriscopeTabArea>
			<PeriscopeTabArea
				count={ relatedCounts[ SonarObjectType.SalesforceApexTrigger ] ?? 0 }
				group={ PERISCOPE_TAB_TYPES.PROCESS_AUTOMATION }
				key={ PERISCOPE_TAB_TYPES.APEX_TRIGGERS }
				requiresCount
				submenu={ PERISCOPE_TAB_TYPES.REFERENCES }
				tab={ PERISCOPE_TAB_TYPES.APEX_TRIGGERS }>
				<EntityAutomationTab
					childType={ SonarObjectChildTypeId.SalesforceApexTrigger }
					index={ index }
					sonarObjectId={ sonarObjectId }
					type={ SfEntityAutomationType.ApexTriggers } />
			</PeriscopeTabArea>
			<PeriscopeTabArea
				count={ relatedCounts[ SonarObjectType.SalesforceWorkflowAlert ] ?? 0 }
				group={ PERISCOPE_TAB_TYPES.PROCESS_AUTOMATION }
				key={ PERISCOPE_TAB_TYPES.EMAIL_ALERTS }
				requiresCount
				submenu={ PERISCOPE_TAB_TYPES.REFERENCES }
				tab={ PERISCOPE_TAB_TYPES.EMAIL_ALERTS }>
				<EntityAutomationTab
					childType={ SonarObjectChildTypeId.SalesforceEmailAlert }
					index={ index }
					sonarObjectId={ sonarObjectId }
					type={ SfEntityAutomationType.EmailAlerts } />
			</PeriscopeTabArea>
			<PeriscopeTabArea
				count={ relatedCounts.sfdcFormulaField ?? 0 }
				key={ PERISCOPE_TAB_TYPES.FORMULA_FIELDS }
				requiresCount
				submenu={ PERISCOPE_TAB_TYPES.REFERENCES }
				tab={ PERISCOPE_TAB_TYPES.FORMULA_FIELDS }>
				<EntityAutomationTab
					childType={ SonarObjectChildTypeId.SalesforceFormulaFields }
					index={ index }
					sonarObjectId={ sonarObjectId }
					type={ SfEntityAutomationType.FormulaFields } />
			</PeriscopeTabArea>
			<PeriscopeTabArea
				count={ relatedCounts[ SonarObjectType.SalesforcePageLayout ] ?? 0 }
				key={ PERISCOPE_TAB_TYPES.PAGE_LAYOUTS }
				requiresCount
				submenu={ PERISCOPE_TAB_TYPES.REFERENCES }
				tab={ PERISCOPE_TAB_TYPES.PAGE_LAYOUTS }>
				<EntityAutomationTab
					childType={ SonarObjectChildTypeId.SalesforcePageLayout }
					index={ index }
					sonarObjectId={ sonarObjectId }
					type={ SfEntityAutomationType.PageLayouts } />
			</PeriscopeTabArea>
			<PeriscopeTabArea
				count={ relatedCounts[ SonarObjectType.SalesforceReport ] ?? 0 }
				key={ PERISCOPE_TAB_TYPES.REPORTS }
				requiresCount
				submenu={ PERISCOPE_TAB_TYPES.REFERENCES }
				tab={ PERISCOPE_TAB_TYPES.REPORTS }>
				<EntityReportsTab
					index={ index }
					sonarObjectId={ sonarObjectId } />
			</PeriscopeTabArea>
			<PeriscopeTabArea
				count={ relatedCounts[ SonarObjectType.SalesforceEntity ] ?? 0 }
				key={ PERISCOPE_TAB_TYPES.RELATED_OBJECTS }
				requiresCount
				tab={ PERISCOPE_TAB_TYPES.RELATED_OBJECTS }>
				<EntityRelatedObjectsTab
					index={ index }
					sonarObjectId={ sonarObjectId } />
			</PeriscopeTabArea>
			<PeriscopeTabArea
				key={ PERISCOPE_TAB_TYPES.LIMITS }
				tab={ PERISCOPE_TAB_TYPES.LIMITS }>
				<EntityLimitsTab sonarObjectId={ sonarObjectId } />
			</PeriscopeTabArea>
			<PeriscopeTabArea
				key={ PERISCOPE_TAB_TYPES.BULK_TAG }
				tab={ PERISCOPE_TAB_TYPES.BULK_TAG }>
				<EntityBulkTagTab sonarObjectId={ sonarObjectId } />
			</PeriscopeTabArea>
		</PeriscopeMenuTabs>
	);
};
